// Lib
import { createAction } from 'redux-actions';

export const UpdatePosts = createAction('UPDATE_POSTS');
export const UpdatePost = createAction('UPDATE_POST');
export const SetLoadingPosts = createAction('SET_LOADING_POSTS');
export const DeletePost = createAction('DELETE_POST');
export const ClearPosts = createAction('CLEAR_POSTS');
